import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_RS.json';
import audios from './ASTROLOGY_AUDIOS_RS.json';

export const ASTROLOGY_DATA_RS: ServiceData = {
  articles,
  audios,
};
